import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import {
  assignCustomizedBooking,
  getCheckoutList,
  getServiceBoyList,
  gstAllCustomizedBooking,
} from "../../Services/Operations/ProductAPI";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";


const RefferProduct = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);

  const [allCustomizedBoking, setAllCustomizedBooking] = useState([]);
  const [serviceBoys, setServiceBoys] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dispatchedCheckout, setDispatchedCheckout] = useState([]);
  const [orderMood, setOrderMood] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentUsers =
    orderMood === 1
      ? dispatchedCheckout.slice(indexOfFirst, indexOfLast)
      : allCustomizedBoking.slice(indexOfFirst, indexOfLast);

  const totalItems =
    orderMood === 1
      ? dispatchedCheckout.length
      : allCustomizedBoking.length;

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const fetchServieBoys = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getServiceBoyList(token);
      console.log("serice boy List: ", response);
      setServiceBoys(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAllCustomizedBooking = async () => {
    try {
      const response = await gstAllCustomizedBooking(token);
      console.log(response);

      if (response.status === 200) {
        setAllCustomizedBooking(response.data.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCheckouts = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getCheckoutList(token);
      console.log("Checkout List: ", response);

      let list = response.filter(
        (item) => item.orderStatus === "DISPATCHED"
      );

      setDispatchedCheckout(list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCheckouts();
    handleAllCustomizedBooking();
    fetchServieBoys();
  }, []);

  const handleTabChange = (tab) => {
    setOrderMood(tab);
    setCurrentPage(1);
  };

  const formatBookingDate = (createdAt) => {
    if (!createdAt) return "—";

    if (Array.isArray(createdAt)) {
      return (
        <>
          {createdAt[2]}/{createdAt[1]}/{createdAt[0]}
          <span className="rp-time">
            ({createdAt[3]}:{String(createdAt[4] ?? 0).padStart(2, "0")})
          </span>
        </>
      );
    }

    const date = new Date(createdAt);

    return isNaN(date.getTime())
      ? "—"
      : date.toLocaleDateString();
  };

  return (
    <div id="main_content" className="rp-page">
      <Header />

      <div className="page">
        <Section />

        <div className="section-body rp-section">
          {/* Page heading */}
          <div className="rp-page-heading">
            <div>
              <span className="rp-eyebrow">BOOKING MANAGEMENT</span>
              <h2>Product Booking & Assignment</h2>
              <p>
                Manage dispatched checkouts and customized product bookings.
              </p>
            </div>

            <div className="rp-heading-icon">
              <i className="fa fa-cubes" />
            </div>
          </div>

          {/* Summary cards */}
          <div className="rp-summary-grid">
            <div className="rp-summary-card">
              <div className="rp-summary-icon rp-icon-red">
                <i className="fa fa-shopping-bag" />
              </div>
              <div>
                <span>Dispatched Checkouts</span>
                <strong>{dispatchedCheckout.length}</strong>
              </div>
            </div>

            <div className="rp-summary-card">
              <div className="rp-summary-icon rp-icon-orange">
                <i className="fa fa-sliders" />
              </div>
              <div>
                <span>Customized Bookings</span>
                <strong>{allCustomizedBoking.length}</strong>
              </div>
            </div>

            <div className="rp-summary-card">
              <div className="rp-summary-icon rp-icon-blue">
                <i className="fa fa-users" />
              </div>
              <div>
                <span>Available Service People</span>
                <strong>{serviceBoys.length}</strong>
              </div>
            </div>
          </div>

          {/* Main content panel */}
          <div className="rp-content-panel">
            <div className="rp-content-header">
              <div>
                <h3>Booking Records</h3>
                <p>View booking information and manage assignments.</p>
              </div>

              <div className="rp-tabs">
                <button
                  className={`rp-tab ${
                    orderMood === 1 ? "rp-tab-active" : ""
                  }`}
                  onClick={() => handleTabChange(1)}
                >
                  <i className="fa fa-shopping-cart" />
                  Checkouts
                  <span>{dispatchedCheckout.length}</span>
                </button>

                <button
                  className={`rp-tab ${
                    orderMood === 2 ? "rp-tab-active" : ""
                  }`}
                  onClick={() => handleTabChange(2)}
                >
                  <i className="fa fa-cube" />
                  Customized
                  <span>{allCustomizedBoking.length}</span>
                </button>
              </div>
            </div>

            {/* Table information */}
            <div className="rp-table-toolbar">
              <div>
                <strong>
                  {orderMood === 1
                    ? "Dispatched Checkouts"
                    : "Customized Bookings"}
                </strong>
                <span>
                  Showing {currentUsers.length} of {totalItems} records
                </span>
              </div>

              <div className="rp-page-indicator">
                Page {currentPage} of {Math.max(totalPages, 1)}
              </div>
            </div>

            {/* Responsive table */}
            <div className="rp-table-wrapper">
              <table className="rp-table">
                <thead>
                  <tr>
                    <th>#</th>

         
                    <th>Date</th>
                    <th>Image</th>
                    <th>Quantity</th>
                    <th>Total Amount</th>
                    <th>Grand Total</th>
                    <th>Test Data</th>
                    <th>Assignment</th>
                  </tr>
                </thead>

                <tbody>
                  {currentUsers.length > 0 ? (
                    currentUsers.map((item, ind) => (
                      <tr key={item.id || item.checkoutId || ind}>
                        <td>
                          <span className="rp-row-number">
                            {indexOfFirst + ind + 1}
                          </span>
                        </td>

                      

                        

                        <td className="rp-date-cell">
                          {formatBookingDate(item?.createdAt)}
                        </td>

                        <td>
                          <span className="rp-image-placeholder">
                            <i className="fa fa-image" />
                            Images
                          </span>
                        </td>

                        <td>
                          <span className="rp-quantity">
                            {item?.items?.length ?? "—"}
                          </span>
                        </td>

                        <td className="rp-price-cell">
                          ₹{item?.totalAmount ?? "—"}
                        </td>

                        <td>
                          <strong className="rp-grand-total">
                            ₹{item?.grandTotal ?? "—"}
                          </strong>
                        </td>

                        <td>
                          <button
                            className="rp-view-btn"
                            title="View test data"
                            onClick={() =>
                              navigate(
                                `/customized-booking-test-data/${item.id}`
                              )
                            }
                          >
                            <i className="fa fa-eye" />
                          </button>
                        </td>

                        <td>
                          {item.servicePersonStatus === "ASSIGNED" ? (
                            <button
                              className="rp-done-btn"
                              onClick={() =>
                                toast.info(
                                  "This order is already Assigned"
                                )
                              }
                            >
                              <i className="fa fa-check-circle" />
                              Done
                            </button>
                          ) : (
                            <button
                              className="rp-assign-btn"
                              onClick={() => setModal(item)}
                            >
                              <i className="fa fa-user-plus" />
                              Assign
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10">
                        <div className="rp-empty-state">
                          <div className="rp-empty-icon">
                            <i className="fa fa-folder-open" />
                          </div>
                          <strong>No booking records found</strong>
                          <span>
                            There are currently no records in this section.
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="rp-pagination">
              <span className="rp-pagination-info">
                Showing {totalItems === 0 ? 0 : indexOfFirst + 1}–
                {Math.min(indexOfLast, totalItems)} of {totalItems}
              </span>

              <div className="rp-pagination-controls">
                <button
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage((prev) => prev - 1)
                  }
                >
                  <i className="fa fa-chevron-left" />
                  Previous
                </button>

                <span className="rp-current-page">
                  {currentPage}
                </span>

                <button
                  disabled={
                    currentPage === totalPages || totalPages === 0
                  }
                  onClick={() =>
                    setCurrentPage((prev) => prev + 1)
                  }
                >
                  Next
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Service person modal */}
        {modal && (
          <div
            className="rp-modal-overlay"
            onClick={() => setModal(null)}
          >
            <div
              className="rp-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="rp-modal-header">
                <div>
                  <span className="rp-eyebrow">BOOKING ASSIGNMENT</span>
                  <h3>Select a Service Person</h3>
                  <p>
                    Choose a service person for this customized booking.
                  </p>
                </div>

                <button
                  className="rp-modal-close"
                  onClick={() => setModal(null)}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="rp-modal-body">
                <div className="rp-selected-booking">
                  <div className="rp-selected-booking-icon">
                    <i className="fa fa-cube" />
                  </div>

                  <div>
                    <span>Selected Product</span>
                    <strong>{modal.productName || "Booking"}</strong>
                  </div>
                </div>

                <div className="rp-service-list-heading">
                  <strong>Available Service People</strong>
                  <span>{serviceBoys.length} available</span>
                </div>

                {serviceBoys.length > 0 ? (
                  <div className="rp-service-list">
                    {serviceBoys.map((item) => (
                      <div
                        className="rp-service-person"
                        key={item.employeeId}
                      >
                        <div className="rp-service-avatar">
                          <i className="fa fa-user" />
                        </div>

                        <div className="rp-service-info">
                          <strong>{item.firstName}</strong>
                          <span>
                            <i className="fa fa-map-marker" />
                            {item.villageTownCity || "Location unavailable"}
                          </span>
                          <small>
                            From: {item.district || "—"}
                          </small>
                        </div>

                        {loading === item.employeeId ? (
                          <span className="rp-service-loading">
                            Loading...
                          </span>
                        ) : (
                          <span className="rp-service-available">
                            <i className="fa fa-circle" />
                            Available
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="rp-empty-state rp-modal-empty">
                    <div className="rp-empty-icon">
                      <i className="fa fa-users" />
                    </div>
                    <strong>No service people available</strong>
                    <span>
                      No service people were returned by the service.
                    </span>
                  </div>
                )}
              </div>

              <div className="rp-modal-footer">
                <button
                  className="rp-cancel-btn"
                  onClick={() => setModal(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="section-body rp-footer">
          <footer className="footer">
            <div className="container-fluid">
              Copyright © 2025{" "}
              <a href="">
                Technology support By - Siance Software Pvt Ltd
              </a>
              .
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default RefferProduct;